var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 1042,
    viewBox: "0 0 720 1042",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1042,
    fill: "#F7FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.703 496.289L307.778 336.406C308.547 334.292 310.47 333.139 312.778 333.139H406.428C408.351 333.139 409.889 333.907 411.043 335.637C412.005 337.174 412.005 338.904 411.428 340.825L383.544 424.418L453.542 412.696C455.849 412.312 457.965 413.465 459.118 415.386C460.08 417.5 459.695 419.806 458.349 421.536L263.933 695.183C262.395 697.297 259.126 697.681 256.818 696.336C254.51 694.798 253.741 692.108 254.703 689.418L319.508 493.791L260.472 503.784C258.549 504.168 256.626 503.207 255.472 501.67C254.318 499.94 254.126 498.211 254.703 496.289Z",
    fill: "url(#paint0_linear_57_919)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_57_919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.859,
    y: 500.977,
    width: 403.799,
    height: 257.334,
    transform: "rotate(-9.56611 153.859 500.977)",
    fill: "#F6F6F6",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_57_919",
    x: 126.049,
    y: 406.062,
    width: 496.569,
    height: 376.481,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_57_919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_57_919",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_919",
    x1: 356.975,
    y1: 333.139,
    x2: 356.975,
    y2: 697.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC29"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterimage);
export default __webpack_public_path__ + "static/media/Register image.596b241764230cd9c789226a2e0284bc.svg";
export { ForwardRef as ReactComponent };